export default "__VITE_ASSET__BjbWZCWB__"